// User Wizard Actions

export const USER_WIZARD_REQUEST = 'USER_WIZARD_REQUEST';
export const USER_WIZARD_SUCCESS = 'USER_WIZARD_SUCCESS';
export const USER_WIZARD_FAIL = 'USER_WIZARD_FAIL';
export const CLEAR_USER_WIZARD_STATE = 'CLEAR_USER_WIZARD_STATE';

// Co User Add Actions

export const COUSER_ADD_REQUEST = 'COUSER_ADD_REQUEST';
export const COUSER_ADD_SUCCESS = 'COUSER_ADD_SUCCESS';
export const COUSER_ADD_FAIL = 'COUSER_ADD_FAIL';

export const COUSER_VERIFY_REQUEST = 'COUSER_VERIFY_REQUEST';
export const COUSER_VERIFY_SUCCESS = 'COUSER_VERIFY_SUCCESS';
export const COUSER_VERIFY_FAIL = 'COUSER_VERIFY_FAIL';

export const SET_WORKFLOW_REQUEST = 'SET_WORKFLOW_REQUEST';
export const SET_WORKFLOW_SUCCESS = 'SET_WORKFLOW_SUCCESS';
export const SET_WORKFLOW_FAIL = 'SET_WORKFLOW_FAIL';

export const GET_WORKFLOW_REQUEST = 'GET_WORKFLOW_REQUEST';
export const GET_WORKFLOW_SUCCESS = 'GET_WORKFLOW_SUCCESS';
export const GET_WORKFLOW_FAIL = 'GET_WORKFLOW_FAIL';

// Co User Setup Account

export const COUSER_SETUPACCOUNT_REQUEST = 'COUSER_SETUPACCOUNT_REQUEST';
export const COUSER_SETUPACCOUNT_SUCCESS = 'COUSER_SETUPACCOUNT_SUCCESS';
export const COUSER_SETUPACCOUNT_FAIL = 'COUSER_SETUPACCOUNT_FAIL';

export const RECENT_COUSER_REQUEST = 'RECENT_COUSER_REQUEST';
export const RECENT_COUSER_SUCCESS = 'RECENT_COUSER_SUCCESS';
export const RECENT_COUSER_FAIL = 'RECENT_COUSER_FAIL';

// Get All Mechanics

export const GET_ALL_MECHANICS_REQUEST = 'GET_ALL_MECHANICS_REQUEST';
export const GET_ALL_MECHANICS_SUCCESS = 'GET_ALL_MECHANICS_SUCCESS';
export const GET_ALL_MECHANICS_FAIL = 'GET_ALL_MECHANICS_FAIL';
export const UPDATE_ALL_MECHANICS = 'UPDATE_ALL_MECHANICS';

// get user

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

// update user account settings

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const CLEAR_UPDATE_USER_STATE = 'CLEAR_UPDATE_USER_STATE';

// change user password

export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAIL = 'CHANGE_USER_PASSWORD_FAIL';
export const CLEAR_CHANGE_USER_PASSWORD_STATE =
  'CLEAR_CHANGE_USER_PASSWORD_STATE';

// update wage rate

export const UPDATE_WAGE_RATE_REQUEST = 'UPDATE_WAGE_RATE_REQUEST';
export const UPDATE_WAGE_RATE_SUCCESS = 'UPDATE_WAGE_RATE_SUCCESS';
export const UPDATE_WAGE_RATE_FAIL = 'UPDATE_WAGE_RATE_FAIL';
export const CLEAR_WAGE_RATE_STATE = 'CLEAR_WAGE_RATE_STATE';

// get all user list

export const GET_ALL_USERS_LIST_REQUEST = 'GET_ALL_USERS_LIST_REQUEST';
export const GET_ALL_USERS_LIST_SUCCESS = 'GET_ALL_USERS_LIST_SUCCESS';
export const GET_ALL_USERS_LIST_FAIL = 'GET_ALL_USERS_LIST_FAIL';

// add gamification details

export const ADD_UPDATE_GAMIFICATION_DETAILS_REQUEST =
  'ADD_UPDATE_GAMIFICATION_DETAILS_REQUEST';
export const ADD_UPDATE_GAMIFICATION_DETAILS_SUCCESS =
  'ADD_UPDATE_GAMIFICATION_DETAILS_SUCCESS';
export const ADD_UPDATE_GAMIFICATION_DETAILS_FAIL =
  'ADD_UPDATE_GAMIFICATION_DETAILS_FAIL';

// get gamification details

export const GET_GAMIFICATION_DETAILS_REQUEST =
  'GET_GAMIFICATION_DETAILS_REQUEST';
export const GET_GAMIFICATION_DETAILS_SUCCESS =
  'GET_GAMIFICATION_DETAILS_SUCCESS';
export const GET_GAMIFICATION_DETAILS_FAIL = 'GET_GAMIFICATION_DETAILS_FAIL';

// clear gamification states

export const CLEAR_GAMIFICATION_STATE = 'CLEAR_GAMIFICATION_STATE';
